namespace SPA
{
	export namespace Realtor
	{
		export namespace gui
		{
			import DateHelper = Helper.DateHelper;

			export class BasicData
			{
				public static Build(object: RealtorObjectModel): JQuery
				{
					const data: SPA.Realtor2.INewDisposalObject = object.Data;
					const advData = object.AdvData;

					const activeSelect = new ui.Form.Select(
						{
							name: 'active',
							control: true,
							option: SPA.types.Convert.ToObjectList(SPA.types.InActive)
						}, advData.active || 'ACTIVE' || 'SELLED'
					);
					activeSelect.Initialize();

					const marketingSelect = new ui.Form.Select(
						{
							name: 'marketing',
							control: true,
							option: SPA.types.Convert.ToObjectList(SPA.types.Object.Marketing)
						}, advData.marketing || 'DisposalRealtorObject'
					);
					marketingSelect.Initialize();

					const typeSelect = new ui.Form.Select(
						{
							blank: ' -- Bitte wählen -- ',
							name: 'type_disabled',
							disabled: true,
							control: true,
							option: SPA.types.Convert.ToObjectList(SPA.types.Object.Type)
						}, data.common.type ? data.common.type.type : advData.type || ''
					);
					typeSelect.Initialize();

					const mandateSelect = new ui.Form.Select(
						{
							blank: ' -- Bitte wählen -- ',
							name: 'sole_mandate',
							control: true,
							option: SPA.types.Convert.ToObjectList(SPA.types.YesNo)
						}, advData.sole_mandate || ''
					);
					mandateSelect.Initialize();

					const compareSelect = new ui.Form.Select(
						{
							blank: '-Wählen-',
							name: 'compare',
							control: true,
							option: SPA.types.Convert.ToObjectList(SPA.types.YesNo)
						}, advData.compare
					);
					compareSelect.Initialize();

					const createDate = DateHelper.getDateFromTstamp(object.CreatedAt.date);

					const immowert = object.ImmoWertV ? accounting.formatMoney(Math.floor(object.ImmoWertV / 1000) * 1000) : '';
					const immowertInput = new ui.Form.TextInput(immowert, {name: 'immowert', classes: ['currency']});
					immowertInput.Initialize();

					const iwvCalc = $('<div class="btn btn-default input-group-addon"><i class="fa fa-calculator "></i></div>');
					iwvCalc.one('click', (e) =>
					{
						const $btn = $(e.delegateTarget);
						const html = $btn.html();

						if ($btn.data('disabled') === true)
						{
							return;
						}

						$btn.data({
							disabled: true,
							html: $btn.html(),
						});

						$btn.html('<i class="fas fa-spinner fa-spin"></i>');
						new Wollmilch.AJAX({
							method: 'GET',
							url: 'object/iwv/' + btoa(object.ObjectNumber),
							data: [],
							on: {
								success: (text) => {
									const json = JSON.parse(text);
									if (json.success === false)
									{
										alert(json.error.code + ":\n" + json.error.msg);
										return;
									}

									if (json.iwv.success === false)
									{
										alert('Fehler bei der Berechnung des ImmoWertV');
										return;
									}
									const value = accounting.formatNumber(Math.floor(json.iwv.data.result.Value.value / 1000) * 1000);
									immowertInput.value(value);
									object.ImmoWertV = json.iwv.data.result.Value.value;
								},
								failed: (status, xhr) =>
								{
									const json = JSON.parse(xhr.responseText);
									if (!json.success) {
										alert(json.error  .code + ":\n" + json.error.msg);
										return;
									}
								},
								always: () =>
								{
									iwvCalc.fadeOut();
									$btn.data('disabled', false);
									$btn.html($btn.data('html'));
								}
							}
						}, AJAXCallbase_e.REALTOR).send();
					});

					let price = advData.price ? advData.price : data.general && data.general.price.value ? data.general.price.value : '';
					price = accounting.formatMoney(price);
					const priceInput = new ui.Form.TextInput(price, {
						name: 'price',
						classes: ['number'],
					});
					priceInput.Initialize();

					const soldPrice = advData.sold_price ? accounting.formatMoney(advData.sold_price) : '';
					const soldPriceInput = new ui.Form.TextInput(soldPrice, {name: 'sold_price', classes: ['number']});
					soldPriceInput.Initialize();

					const ertragswert = advData.ertragswert ? accounting.formatMoney(advData.ertragswert) : '';
					const ertragswertInput = new ui.Form.TextInput(ertragswert, {name: 'ertragswert', classes: ['number']});
					ertragswertInput.Initialize();

					const belwert = advData.belwert ? accounting.formatMoney(advData.belwert) : '';
					const belwertInput = new ui.Form.TextInput(belwert, {name: 'belwert', classes: ['number']});
					belwertInput.Initialize();

					let buildingValue = advData.building ? accounting.formatNumber(advData.building)
						: data.property ? accounting.formatNumber(data.property.area.building) : '';
					const buildingInput = new ui.Form.TextInput(buildingValue, {name: 'building', classes: ['number iwv-req']});
					buildingInput.Initialize();

					const areaText = ui.$$.p().addClass('form-control-static');

					let gardenValue = advData.garden ? accounting.formatNumber(advData.garden)
						: data.property ? accounting.formatNumber(data.property.area.garden) : '';
					const gardenInput = new ui.Form.TextInput(gardenValue, {name: 'garden', classes: ['number iwv-req']});
					gardenInput.Initialize();

					// Auto-Calculate total area
					buildingInput.Input().on('change', (e) => {
						const g = accounting.unformat(gardenValue.replace('.', ''));
						const b = accounting.unformat((e.currentTarget as HTMLInputElement).value.replace('.', ''));

						buildingValue = b.toString();
						areaText.text(accounting.formatNumber(g + b) + ' m²');
					});
					gardenInput.Input().on('change', (e) => {
						const g = accounting.unformat((e.currentTarget as HTMLInputElement).value.replace('.', ''));
						const b = accounting.unformat(buildingValue.replace('.', ''));

						gardenValue = g.toString();
						areaText.text(accounting.formatNumber(g + b) + ' m²');
					});

					const areaValue = advData.area ? accounting.formatNumber(advData.area)
						: data.property ? accounting.formatNumber(data.property.area.garden + data.property.area.building) : '';

					const bgfValue = advData.bgf ? accounting.formatNumber(advData.bgf)
						: data.details && data.details.living_area.type === 'BGF' && data.details.living_area.value ? accounting.formatNumber(data.details.living_area.value) : '';
					const bgfInput = new ui.Form.TextInput(bgfValue, {name: 'bgf', classes: ['number iwv-req']});
					bgfInput.Initialize();

					const nfValue = advData.nf ? accounting.formatNumber(advData.nf) : '';
					const nfInput = new ui.Form.TextInput(nfValue, {name: 'nf', classes: ['number']});
					nfInput.Initialize();

					const ngfValue = advData.ngf ? accounting.formatNumber(advData.ngf)
						: data.details && data.details.living_area.type === 'NGF' && data.details.living_area.value ? accounting.formatNumber(data.details.living_area.value) : '';
					const ngfInput = new ui.Form.TextInput(ngfValue, {name: 'ngf', classes: ['number iwv-req']});
					ngfInput.Initialize();

					const template = $('<fieldset />')
						.append('<legend>Objekt &nbsp; Basisdaten</legend>')
						.append(ui.$$.div().addClass('row').append(
							SPA.gui.Bootstrap.Column('col-sm-3 col-md-2 col-lg-3',
								new ui.base.BaseHTMLElement('label').addClass('control-label').text('Referenz-Nr.'),
								new ui.Form.TextInput(advData.ref_no, {name: 'ref_no'})
							)
							.add(SPA.gui.Bootstrap.Column('col-sm-4 col-md-2 col-lg-4',
								new ui.base.BaseHTMLElement('label').addClass('control-label').text('Status'),
								activeSelect
							))
							.add(SPA.gui.Bootstrap.Column('col-sm-5 col-md-2 col-lg-5',
								new ui.base.BaseHTMLElement('label').addClass('control-label').text('Angelegt am'),
								new ui.Form.TextInput(createDate, {name: 'created_at', disabled: true})
							))
							.add(SPA.gui.Bootstrap.Column('col-sm-5 col-md-2 col-lg-5',
								new ui.base.BaseHTMLElement('label').addClass('control-label').text('Vermarktungsart'),
								marketingSelect
							))
							.add(SPA.gui.Bootstrap.Column('col-sm-7 col-md-4 col-lg-7',
								new ui.base.BaseHTMLElement('label').addClass('control-label').text('Haustyp'),
								typeSelect,
								`<input type="hidden" name="type" value="${data.common.type ? data.common.type.type : advData.type}">`
							))
						))
						.append(ui.$$.div().addClass('row').append(
							SPA.gui.Bootstrap.Column('col-sm-6 col-md-3 col-lg-6',
								new ui.base.BaseHTMLElement('label').addClass('control-label').text('Angebotspreis'),
								$('<div class="input-group">').append(priceInput.Input().add('<span class="input-group-addon">€</span>'))
							)
							.add(SPA.gui.Bootstrap.Column('col-sm-6 col-md-3 col-lg-6',
								new ui.base.BaseHTMLElement('label').addClass('control-label').text('verkauft am'),
								`<input type="date" class="form-control" name="sold_at" value="${advData.sold_at || ''}">`
							))
							.add(SPA.gui.Bootstrap.Column('col-sm-6 col-md-3 col-lg-6',
								new ui.base.BaseHTMLElement('label').addClass('control-label nobreak').text('erzielter Verkaufspreis'),
								$('<div class="input-group">').append(soldPriceInput.Input().add('<span class="input-group-addon">€</span>'))
							))
							.add(SPA.gui.Bootstrap.Column('col-sm-4 col-md-3 col-lg-4',
								new ui.base.BaseHTMLElement('label').addClass('control-label').text('Baujahr'),
								new ui.Form.TextInput(data.details && data.details.object.construction_year ? data.details.object.construction_year.toString(10) : '', {name: 'construction_year', classes: ['iwv-req']})
							))
						))
						.append(ui.$$.div().addClass('row').append(
							SPA.gui.Bootstrap.Column('col-sm-4',
								new ui.base.BaseHTMLElement('label').addClass('control-label').text('Notartermin am'),
								$(`<input type="date" class="form-control" name="notary_date" value="${advData.notary_date || ''}">`)
							)
							.add(SPA.gui.Bootstrap.Column('col-sm-4',
								new ui.base.BaseHTMLElement('label').addClass('control-label').text('Alleinmandat'),
								mandateSelect
							))
							.add(SPA.gui.Bootstrap.Column('col-sm-4',
								new ui.base.BaseHTMLElement('label').addClass('control-label').text('Mandat bis'),
								$(`<input type="date" class="form-control" name="mandate_till" value="${advData.mandate_till || ''}">`)
							))
						))
						.append(ui.$$.div().addClass('row').append(
							SPA.gui.Bootstrap.Column('col-sm-6 col-md-2 col-lg-6',
								new ui.base.BaseHTMLElement('label').addClass('control-label').text('Vergleichswert'),
								compareSelect.addClass('input-group btn-block')
							)
							.add(SPA.gui.Bootstrap.Column('col-sm-6 col-md-3 col-lg-6',
								new ui.base.BaseHTMLElement('label').addClass('control-label').text('Ertragswert'),
								$('<div class="input-group">').append(ertragswertInput.Input().add('<span class="input-group-addon">€</span>'))
							))
							.add(SPA.gui.Bootstrap.Column('col-sm-6 col-md-3 col-lg-6',
								new ui.base.BaseHTMLElement('label').addClass('control-label').text('BelWertV'),
								$('<div class="input-group">').append(belwertInput.Input().add('<span class="input-group-addon">€</span>'))
							))
							.add(SPA.gui.Bootstrap.Column('col-sm-6 col-md-4 col-lg-6',
								new ui.base.BaseHTMLElement('label').addClass('control-label').text('ImmoWertV'),
								$('<div class="input-group">').append(immowertInput.Input()).append('<span class="input-group-addon">€</span>').append(iwvCalc)
							))
						))
						.append(ui.$$.div().addClass('row').append(
							SPA.gui.Bootstrap.Column('col-sm-4 col-md-3 col-lg-4',
								new ui.base.BaseHTMLElement('label').addClass('control-label').text('Bebaubare Fläche'),
								$('<div class="input-group form-group">').append(buildingInput.Input()).append('<div class="input-group-addon"><span>m²</span></div>')
							)
							.add(SPA.gui.Bootstrap.Column('col-sm-4 col-md-3 col-lg-4',
								new ui.base.BaseHTMLElement('label').addClass('control-label').text('Garten-/Hinterland'),
								$('<div class="input-group form-group">').append(gardenInput.Input()).append('<div class="input-group-addon"><span>m²</span></div>')
							))
							.add(SPA.gui.Bootstrap.Column('col-sm-4 col-md-3 col-lg-4',
								new ui.base.BaseHTMLElement('label').addClass('control-label').text('Grundstücksfläche'),
								$('<div class="input-group form-group">').append(areaText.text(areaValue + ' m²'))
							))
						))
						.append(ui.$$.div().addClass('row').append(
							SPA.gui.Bootstrap.Column('col-sm-4 col-md-3 col-lg-4',
								new ui.base.BaseHTMLElement('label').addClass('control-label').text('Bruttogrundfläche'),
								$('<div class="input-group form-group">').append(bgfInput.Input()).append('<div class="input-group-addon"><span>m²</span></div>')
							)
								/*
							.add(SPA.gui.Bootstrap.Column('col-sm-3',
								new ui.base.BaseHTMLElement('label').addClass('control-label').text('Nutzfläche'),
								$('<div class="input-group form-group">').append(nfInput.Input()).append('<div class="input-group-addon"><span>m²</span></div>')
							))
							*/
							.add(SPA.gui.Bootstrap.Column('col-sm-4 col-md-3 col-lg-4',
								new ui.base.BaseHTMLElement('label').addClass('control-label').text('Wohnfläche'),
								$('<div class="input-group form-group">').append(ngfInput.Input()).append('<div class="input-group-addon"><span>m²</span></div>')
							))
						))
						.append(BasicData.BuildOptional(object));

					return template;
				}

				private static BuildOptional(object: RealtorObjectModel): JQuery
				{
					const data = object.Data;
					const advData = object.AdvData;

					const grannyFlatSelect = new ui.Form.Select(
						{
							blank: ' -- Bitte wählen -- ',
							name: 'granny_flat',
							control: true,
							option: SPA.types.Convert.ToObjectList(SPA.types.YesNo)
						}, advData.granny_flat
					);
					grannyFlatSelect.Initialize();

					const stairlessSelect = new ui.Form.Select(
						{
							blank: ' -- Bitte wählen -- ',
							name: 'stairless_access',
							control: true,
							option: SPA.types.Convert.ToObjectList(SPA.types.YesNo)
						}, advData.stairless_access
					);
					stairlessSelect.Initialize();

					const guestToilet = new ui.Form.Select(
						{
							blank: ' -- Bitte wählen -- ',
							name: 'guest_toilet',
							control: true,
							option: SPA.types.Convert.ToObjectList(SPA.types.YesNo)
						}, advData.guest_toilet
					);
					guestToilet.Initialize();

					const parkingSegmentList = ui.$$.div();
					if (!data.details || data.details.parking.length === 0)
					{
						parkingSegmentList.append('<span>Nein</span>');
					} else {
						for (const segment of data.details.parking)
						{
							parkingSegmentList.append(
								ui.$$.div().html('<small>' +
									SPA.types.Object.ParkingSegment[segment.type]
									+ ' (' + segment.construction_year + ')'
									+ '</small>'
								)
							);
						}
					}

					const leaseSelect = new ui.Form.Select(
						{
							blank: ' -- Bitte wählen -- ',
							name: 'leased',
							control: true,
							option: SPA.types.Convert.ToObjectList(SPA.types.YesNo)
						}, advData.leased
					);
					leaseSelect.Initialize();

					const preservationSelect = new ui.Form.Select(
						{
							blank: ' -- Bitte wählen -- ',
							name: 'preservation_order',
							control: true,
							option: SPA.types.Convert.ToObjectList(SPA.types.YesNo)
						}, advData.preservation_order
					);
					preservationSelect.Initialize();

					const residenceSelect = new ui.Form.Select(
						{
							blank: ' -- Bitte wählen -- ',
							name: 'summer_residence',
							control: true,
							option: SPA.types.Convert.ToObjectList(SPA.types.YesNo)
						}, advData.summer_residence
					);
					residenceSelect.Initialize();

					const buildingPhaseSelect = new ui.Form.Select(
						{
							blank: ' -- Bitte wählen -- ',
							name: 'building_phase',
							control: true,
							option: SPA.types.Convert.ToObjectList(SPA.types.Object.BuildingPhase)
						}, advData.building_phase
					);
					buildingPhaseSelect.Initialize();

					const objectConditionSelect = new ui.Form.Select(
						{
							blank: ' -- Bitte wählen -- ',
							control: true,
							classes: ['iwv-req'],
							name: 'object_condition',
							option: SPA.types.Convert.ToObjectList(SPA.types.Object.Condition)
						}, data.modernization.object_condition.value || advData.object_condition || undefined
					);
					objectConditionSelect.Initialize();

                    let featureSelectDefault;
                    if(advData.features) {
                        featureSelectDefault = advData.features;
                    } else if(data.common && data.common.type) {
                        featureSelectDefault = data.common.type.features.overall;
                    } else{
                        featureSelectDefault = undefined;
                    }

					const featureSelect = new ui.Form.Select(
						{
							blank: ' -- Bitte wählen -- ',
							control: true,
							name: 'features',
							option: SPA.types.Convert.ToObjectList(SPA.types.Object.Interior)
						}, featureSelectDefault
					);
					featureSelect.Initialize();

					const energyCertificateSelect = new ui.Form.Select(
						{
							blank: ' -- Bitte wählen -- ',
							control: true,
							name: 'energy_certificate',
							option: SPA.types.Convert.ToObjectList(SPA.types.Object.EnergieCertificate)
						}, advData.energy_certificate || undefined
					);
					energyCertificateSelect.Initialize();

					let heatingFeature = advData ? advData.energy_source : undefined;
					if (!heatingFeature && data.common)
					{
						for (const i of Object.keys(data.common.heating.features)) {
							if (data.common.heating.features[i] === true) {
								heatingFeature = i;
								break;
							}
						}
					}
					const objectHeatingSelect = new ui.Form.Select(
						{
							blank: ' -- Bitte wählen -- ',
							control: true,
							name: 'energy_source',
							option: SPA.types.Convert.ToObjectList(SPA.types.Object.HeatingFeature)
						}, heatingFeature
					);
					objectHeatingSelect.Initialize();

					let heatingType = advData ? advData.energy_type : undefined;
					if (!heatingType && data.common)
					{
						for (const type of Object.keys(data.common.heating.type)) {
							if (data.common.heating.type[type] === true) {
								heatingType = type;
								break;
							}
						}
					}
					const heatingTypeSelect = new ui.Form.Select({
						blank: ' -- Bitte wählen -- ',
						control: true,
						name: 'energy_type',
						option: SPA.types.Convert.ToObjectList(SPA.types.Object.HeatingType)
					}, heatingType);
					heatingTypeSelect.Initialize();

					const ngfValue = advData.ngf ? accounting.formatNumber(advData.ngf)
						: data.details && data.details.living_area.type === 'NGF' && data.details.living_area.value ? accounting.formatNumber(data.details.living_area.value) : '';
					const ngfInput = new ui.Form.TextInput(ngfValue, {name: 'ngf', classes: ['number']});
					ngfInput.Initialize();

					const garageValue = advData.parking_price ? accounting.formatMoney(advData.parking_price) : '';
					const garageInput = new ui.Form.TextInput(garageValue, {name: 'parking_price', classes: ['number']});
					garageInput.Initialize();

					const yrValue = advData.yearly_rent ? accounting.formatNumber(advData.yearly_rent)
						: data.general && data.general.yearlyRent && data.general.yearlyRent.value ? accounting.formatNumber(data.general.yearlyRent.value) : '';
					const yrInput = new ui.Form.TextInput(yrValue, {name: 'yearly_rent', classes: ['number']});
					yrInput.Initialize();
					const cellarValue = advData.cellar > 0 ? advData.cellar : '0';
					const cellarInput = new ui.Form.TextInput(cellarValue, {name: 'cellar', classes: ['number']});
					cellarInput.Initialize();
					const heatingInfo = data.modernization.redevelopment.heating_system;

					const template = ui.$$.div().addClass('row less-more-container')
						.append(
							SPA.gui.Bootstrap.Column('col-sm-12',
								new ui.base.BaseHTMLElement('h3').text('Ausstattung ')
									.append(new ui.base.BaseHTMLElement('small').addClass('less-more-trigger').text('weniger anzeigen'))
							)
							.add(SPA.gui.Bootstrap.Column('col-sm-5 col-md-3 col-lg-5',
								new ui.base.BaseHTMLElement('label').addClass('control-label').text('Zustand der Immobilie'),
								objectConditionSelect
							))
							.add(SPA.gui.Bootstrap.Column('col-sm-4 col-md-3 col-lg-4',
								new ui.base.BaseHTMLElement('label').addClass('control-label').text('Ausstattung'),
								featureSelect
							))
							.add(SPA.gui.Bootstrap.Column('col-sm-3 col-md-2 col-lg-3',
								new ui.base.BaseHTMLElement('label').addClass('control-label').text('Etagen(Anzahl)'),
								new ui.Form.TextInput(data.common && data.common.type !== null ? data.common.type.floor : 0, {name: 'floor'})
							))
							.add(SPA.gui.Bootstrap.Column('col-sm-4 col-lg-5',
								new ui.base.BaseHTMLElement('label').addClass('control-label').text('Letzte Modernisierung'),
								new ui.Form.TextInput(advData.modernization || '', {name: 'modernization'})
							))

							.add(SPA.gui.Bootstrap.Column('col-sm-4 col-lg-3',
								new ui.base.BaseHTMLElement('label').addClass('control-label').text('Unterkellert'),
								$('<div class="input-group">').append(cellarInput.Input().add('<span class="input-group-addon">%</span>'))
							))
							.add(SPA.gui.Bootstrap.Column('col-sm-4',
							new ui.base.BaseHTMLElement('label').addClass('control-label').text('Vermietet'),
							leaseSelect
							))
							.add(SPA.gui.Bootstrap.Column('col-sm-6 col-md-4 col-lg-6',
								new ui.base.BaseHTMLElement('label').addClass('control-label').text('bezugsfertig ab'),
								new ui.Form.TextInput(advData.bezugsfrei_ab || '', {name: 'bezugsfrei_ab'})
							))
							.add(SPA.gui.Bootstrap.Column('col-sm-6 col-md-6 col-lg-6',
								new ui.base.BaseHTMLElement('label').addClass('control-label').text('Garage/Stellplatz'),
								parkingSegmentList
							))

							.add(
								ui.$$.div().addClass('clearfix less-more less-more-hidden').css({display: 'block'}).append(

									SPA.gui.Bootstrap.Column('col-sm-3 col-md-2 col-lg-3',
										new ui.base.BaseHTMLElement('label').addClass('control-label').text('Zimmeranzahl'),
										new ui.Form.TextInput(advData.rooms || '', {name: 'rooms'})
									)
									.add(SPA.gui.Bootstrap.Column('col-sm-3 col-md-2 col-lg-3',
										new ui.base.BaseHTMLElement('label').addClass('control-label').text('Schlafzimmer'),
										new ui.Form.TextInput(advData.bedroom_count || '', {name: 'bedroom_count'})
									))
									.add(SPA.gui.Bootstrap.Column('col-sm-3 col-md-2 col-lg-3',
										new ui.base.BaseHTMLElement('label').addClass('control-label').text('Badezimmer'),
										new ui.Form.TextInput(advData.bathroom_count || '', {name: 'bathroom_count'})
									))
									.add(SPA.gui.Bootstrap.Column('col-sm-3 col-md-2 col-lg-3',
										new ui.base.BaseHTMLElement('label').addClass('control-label').text('Kinderzimmer'),
										new ui.Form.TextInput(advData.childroom_count || '', {name: 'childroom_count'})
									))

									.add(SPA.gui.Bootstrap.Column('col-sm-4',
										new ui.base.BaseHTMLElement('label').addClass('control-label').text('Gäste-WC'),
										guestToilet
									))
									.add(SPA.gui.Bootstrap.Column('col-sm-4',
										new ui.base.BaseHTMLElement('label').addClass('control-label').text('Einliegerwohnung'),
										grannyFlatSelect
									))
									.add(SPA.gui.Bootstrap.Column('col-sm-4',
										new ui.base.BaseHTMLElement('label').addClass('control-label').text('Stufenloser Zugang'),
										stairlessSelect
									))
									.add(SPA.gui.Bootstrap.Column('col-sm-4',
										new ui.base.BaseHTMLElement('label').addClass('control-label').text('Denkmalschutzobjekt'),
										preservationSelect
									))
									.add(SPA.gui.Bootstrap.Column('col-sm-4',
										new ui.base.BaseHTMLElement('label').addClass('control-label').text('Ferienhaus geeignet'),
										residenceSelect
									))
									.add(SPA.gui.Bootstrap.Column('col-sm-4',
										new ui.base.BaseHTMLElement('label').addClass('control-label').text('Bauphase'),
										buildingPhaseSelect
									))
									.add(SPA.gui.Bootstrap.Column('col-sm-4',
									new ui.base.BaseHTMLElement('label').addClass('control-label').text('Jahresmiete'),
									$('<div class="input-group">').append(yrInput.Input().add('<span class="input-group-addon">€</span>'))
									))
									.add(SPA.gui.Bootstrap.Column('col-sm-8 col-md-6 col-lg-8',
										new ui.base.BaseHTMLElement('label').addClass('control-label').text('Garagen/Stellplatz Verkaufspreis'),
										$('<div class="input-group">').append(garageInput.Input().add('<span class="input-group-addon">€</span>'))
									))
								)
							)
						)
						.add(ui.$$.div().addClass('row')
							.append(ui.$$.div().addClass('col-sm-12').css({marginTop: '1em'})
								.append('<h3>Heizung und Heizausstattung</h3>')
							)
							.append(ui.$$.div().addClass('col-sm-6')
								.append(ui.$$.label().text('Energieausweis'))
								.append(energyCertificateSelect.Root())
							)
							.append(ui.$$.div().addClass('col-sm-6').attr('id', 'objectHeatingSelect')
								.append(ui.$$.label().text('Wesentlicher Energieträger'))
								.append(objectHeatingSelect.Input())
							)
						)
						.add(ui.$$.div().addClass('row')
							.append(SPA.gui.Bootstrap.Column('col-sm-6',
								new ui.base.BaseHTMLElement('label').addClass('control-label').text('Heizungsbaujahr'),
								new ui.Form.TextInput(heatingInfo && heatingInfo.year !== null ? heatingInfo.year.toString(10) : data.details.object.construction_year.toString(10), {name: 'heating_year'})
							))
							.append(SPA.gui.Bootstrap.Column('col-sm-6',
								new ui.base.BaseHTMLElement('label').addClass('control-label').text('Heizungsart'),
								heatingTypeSelect.Input()
							))
						)
					;

					return template;
				}
			}
		}
	}
}
